import { Typography } from '@fabric/typography';
import React from 'react';
import { RendererProps } from '../types';

export function DebugRenderer({ element }: RendererProps) {
	return <Typography>{element.type}</Typography>;
}
